var render = function render(){var _vm=this,_c=_vm._self._c;return _c('task-row',{attrs:{"label":_vm.label,"col":""}},[(_vm.loading)?_c('u-fake-loader'):_c(_vm.relation.entity,{tag:"component",attrs:{"value":_vm.dados,"relation":_vm.relation,"task":_vm.task}},[_vm._v(" "+_vm._s(_vm.dados.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }